<div class="main-content">
    <div class="not-found">
        <h1>Ju nuk keni të drejta të aksesoni këtë faqe!</h1>
    </div>
</div>